'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.makeSaga = makeSaga;

var _fsaSaga = require('@zaibot/fsa-saga');

var _effects = require('redux-saga/effects');

var _utils = require('../utils');

function* noop(param) {}
function makeSaga(descriptor) {
    let actions = [...descriptor.actions.all];

    for (var _len = arguments.length, middlewares = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        middlewares[_key - 1] = arguments[_key];
    }

    let f = (0, _utils.applyMiddlewares)(...middlewares);
    return function* internal() {
        yield (0, _fsaSaga.takeEvery)(actions, function* (action) {
            yield (0, _effects.fork)(() => f({ action: action, descriptor: descriptor }, noop));
        });
    };
}
//# sourceMappingURL=makeSaga.js.map


// WEBPACK FOOTER //
// ./node_modules/redux-saga-resources/node/resource/makeSaga.js